/**
 * Redux Store Configuration
 */

import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import marketReducer from './slices/marketSlice';
import orderReducer from './slices/orderSlice';
import portfolioReducer from './slices/portfolioSlice';
import watchlistReducer from './slices/watchlistSlice';
import secureStorage from '../utils/secureStorage';

// Preload auth state from storage before creating the store
const preloadedAuthState = () => {
  const authData = secureStorage.getItem('authData');
  if (authData && authData.token) {
    return {
      isAuthenticated: true,
      userSession: authData.userSession,
      userId: authData.userId,
      clientId: authData.clientId,
      token: authData.token,
      wsSession: null,
      orderToken: null,
      loading: false,
      error: null,
    };
  }
  return undefined;
};

export const store = configureStore({
  reducer: {
    auth: authReducer,
    market: marketReducer,
    orders: orderReducer,
    portfolio: portfolioReducer,
    watchlist: watchlistReducer,
  },
  preloadedState: {
    auth: preloadedAuthState(),
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types for socket connections
        ignoredActions: ['market/setSocket'],
        // Ignore these field paths in state
        ignoredPaths: ['market.socket'],
      },
    }),
});

export default store;
